import { useState, useEffect } from 'react';
import { api } from './hrApi';

const ICONS = {
  'Casual Leave':       { emoji: '🏖️', color: '#E97451' },
  'Compensatory off':   { emoji: '🔄', color: '#E5A624' },
  'Paternity Leave':    { emoji: '👶', color: '#6CACE4' },
  'Privileged Leave':   { emoji: '🛡️', color: '#0E9F8A' },
  'Short Leave':        { emoji: '⏱️', color: '#9B6FD4' },
  'Sick Leave':         { emoji: '🏥', color: '#DC4C64' },
  'Maternity Leave':    { emoji: '🤱', color: '#E97498' },
  'Work From Home':     { emoji: '🏠', color: '#5B8DEF' },
};
const fallback = { emoji: '📋', color: '#64718A' };

function LeaveCard({ t }) {
  const cfg = ICONS[t.name] || fallback;
  const avail = t.available ?? 0;
  const booked = t.booked ?? 0;
  const total = t.total;
  const isHours = (t.unit || '').toLowerCase().includes('hour');
  const hasData = avail > 0 || booked > 0;

  return (
    <div className="lv-card" style={{ '--lv-accent': cfg.color }}>
      <div className="lv-name">{t.name}</div>
      <div className="lv-icon">{cfg.emoji}</div>
      <div className="lv-rows">
        <div className="lv-row">
          <span className="lv-label">Available</span>
          <span className="lv-val" style={{ color: hasData && avail > 0 ? cfg.color : 'var(--ink)' }}>
            {avail}
          </span>
        </div>
        <div className="lv-row">
          <span className="lv-label">Booked</span>
          <span className="lv-val">{booked}{total ? ` / ${total}` : ''}</span>
        </div>
      </div>
      <div className="lv-unit">{isHours ? 'Hours' : 'Days'}</div>
    </div>
  );
}

export default function Leaves() {
  const [items, setItems]       = useState([]);
  const [requests, setRequests] = useState([]);
  const [note, setNote]         = useState('');
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    api('/leaves').then(d => { setItems(d.items); setNote(d.note || ''); })
      .catch(() => {}).finally(() => setLoading(false));
    api('/leave_requests').then(d => setRequests(d.items || [])).catch(() => {});
  }, []);

  return (
    <section className="page on">
      <h2 className="pagetitle display">Leaves</h2>
      <div className="pagesub">Your leave balances from Zoho People.</div>

      {loading ? <div className="loading">Loading leave balance…</div> :
       note ? <div className="soon">{note}</div> :
       !items.length ? <div className="soon">No leave types found.</div> : (
        <div className="lv-grid">
          {items.map((t, i) => <LeaveCard key={i} t={t} />)}
        </div>
      )}

      <button className="primary" disabled title="Coming soon" style={{ marginTop: 20 }}>
        Apply for leave
      </button>
      <span className="note" style={{ marginLeft: 10 }}>Applying from the portal is coming soon.</span>

      {requests.length > 0 && (
        <>
          <h3 className="lv-section-title">Leave requests this year</h3>
          <table className="t">
            <thead>
              <tr><th>TYPE</th><th>FROM</th><th>TO</th><th>DAYS</th><th>STATUS</th><th>REASON</th></tr>
            </thead>
            <tbody>
              {requests.map((r, i) => (
                <tr key={i}>
                  <td>{r.leave_type}</td>
                  <td>{r.from_date}</td>
                  <td>{r.to_date}</td>
                  <td>{r.days}</td>
                  <td>
                    <span className={`pill ${
                      r.status?.toLowerCase().includes('approved') ? 'ok' :
                      r.status?.toLowerCase().includes('reject') ? 'bad' : 'mut'
                    }`}>{r.status || '—'}</span>
                  </td>
                  <td>{r.reason || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
}
